import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { DynamicformsService } from '../../services/dynamicforms.service';
import {
  UntypedFormControl,
  Validators,
  FormGroupDirective,
  NgForm,
  UntypedFormGroup,
  UntypedFormBuilder,
} from '@angular/forms';
import { DuplicatecheckService } from 'src/app/modules/dbpersona/services/duplicatecheck.service';
import { FileService } from '../attachment-dialog/file.service';

import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DynamicFormComponent } from '../dynamicUI/dynamic-form/dynamic-form.component';
import { ErrorStateMatcher } from '@angular/material/core';
import { GenModelService } from 'src/app/core/services/gen-model.service';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-create-candidate',
  templateUrl: './create-candidate.component.html',
  styleUrls: ['./create-candidate.component.scss'],
  standalone: false,
})
export class CreateCandidateComponent implements OnInit {
  @ViewChild(DynamicFormComponent) dynamicFormComponent: DynamicFormComponent;
  @ViewChild('attachmentRef') attachmentRef: any;
  reqgenModel: any;
  matcher = new MyErrorStateMatcher();
  referenceCode = new UntypedFormControl('', [
    Validators.required,
    Validators.pattern(
      '^[A-Z]*-[a-zA-Z0-9 ]*-[0-9]*$|^[A-Z]*-[a-zA-Z ]*-[0-9]*-[0-9]$|^[A-Z]*-[a-zA-Z0-9 ]*-[0-9]*-[0-9]$',
    ),
  ]);
  refereeId = new UntypedFormControl('', [
    Validators.required,
    Validators.pattern('^[0-9]*$'),
    Validators.maxLength(10),
    Validators.minLength(4),
  ]);
  subconId = new UntypedFormControl('');
  publicationDetails: any;
  fileData: any;
  fileCheck: boolean = false;
  formSubmission: boolean = false;
  companyHiringType = localStorage.getItem('fresherCompHiringTypeId');
  referalFlag: boolean;
  codeFlag: boolean;
  label: any;
  allowedTypes = '.doc,.docx,.pdf';
  exInfy: boolean = false;
  exInfyForm: UntypedFormGroup;
  referenceCodeError: boolean = false;
  subconReferral: boolean;
  skills: any;
  subconReferralSourceIds = [16, 48, 4810];
  // 16: sourceId for IL subcon conversion, 48: BPM subcon conversion, 4810: FTR to FTE Conversion

  constructor(
    private detailsService: DuplicatecheckService,
    private apiData: DynamicformsService,
    private fileService: FileService,
    @Inject(NgxUiLoaderService) private ngxLoader: NgxUiLoaderService,
    private fb: UntypedFormBuilder,
    private genmodelservice: GenModelService,
  ) {}

  ngOnInit() {
    this.exInfyForm = this.fb.group({
      exinfoscion: [
        '',
        [Validators.required, Validators.pattern('^[0-9]*$'), Validators.maxLength(10), Validators.minLength(4)],
      ],
    });

    // Set subconId validators based on company hiring type
    if (this.companyHiringType === '4') {
      this.subconId.setValidators([Validators.required, Validators.pattern('^[0-9]{6,7}$')]);
    } else if (this.companyHiringType === '1') {
      this.subconId.setValidators([Validators.required, Validators.pattern('^[0-9]{7}$')]);
    }
    this.subconId.updateValueAndValidity();

    this.apiData.getCreateGen(this.companyHiringType).subscribe((data) => {
      if (data) {
        this.reqgenModel = data;
        if (this.reqgenModel.exEmployeeNumber) {
          this.exInfy = true;
          this.exInfyForm.patchValue({
            exinfoscion: this.reqgenModel.exEmployeeNumber,
          });
        }
      }
    });
    this.referenceCode.valueChanges.subscribe((_x) => {
      this.codeFlag = false;
      this.referalFlag = false;
      this.referenceCodeError = false;
    });
  }

  keyPressedAlphabets(e) {
    //disabled alphabets keys for  phone number
    const key = document.all ? e.keyCode : e.which;
    return (
      (key > 64 && key < 91) ||
      (key > 96 && key < 123) ||
      key == 8 ||
      key == 32 ||
      (key >= 48 && key <= 57) ||
      key == 45
    );
  }

  CheckRefDetails() {
    this.referenceCodeError = false;
    const referalCode = this.referenceCode.value.trim();
    this.detailsService.getJobDescriptionDetails(referalCode).subscribe((details) => {
      this.publicationDetails = details;
      if (this.publicationDetails) {
        if (this.publicationDetails.companyHiringTypeId == this.companyHiringType) {
          this.referenceCodeError = false;
        } else {
          this.referenceCodeError = true;
          // console.log(this.referenceCodeError,"err");
          return false;
        }
      }
      this.codeFlag = true;
      if (
        this.publicationDetails.sourceId == '2' ||
        this.publicationDetails.sourceId == '22' ||
        this.publicationDetails.sourceId == '42' ||
        this.publicationDetails.sourceId == '52' ||
        this.publicationDetails.sourceId == '62' ||
        this.publicationDetails.sourceId == '82' ||
        this.publicationDetails.sourceId == '92'
      ) {
        this.referalFlag = true;
      } else {
        this.referalFlag = false;
      }
      if (this.subconReferralSourceIds.includes(this.publicationDetails.sourceId)) {
        this.subconReferral = true;
        console.log(this.publicationDetails);
      } else {
        this.subconReferral = false;
      }
    });
  }

  // toggle chnage ex infy
  onToggleChangeExInfy() {
    this.exInfy = !this.exInfy;
    if (!this.exInfy) {
      this.exInfyForm.get('exinfoscion').reset();
      this.exInfyForm
        .get('exinfoscion')
        .setValidators([
          Validators.required,
          Validators.pattern('^[0-9]*$'),
          Validators.maxLength(10),
          Validators.minLength(4),
        ]);
      this.exInfyForm.updateValueAndValidity();
    }
    // if(!this.exInfy){
    //   this.exInfyForm.get('exinfoscion').clearValidators();
    //   this.exInfyForm.updateValueAndValidity();
    // }
    // else{
    //   this.exInfyForm.get('exinfoscion').markAsUntouched();
    //   this.exInfyForm.get('exinfoscion').setValidators([Validators.required, Validators.pattern('^[0-9]*$'), Validators.maxLength(10), Validators.minLength(4)]);
    //   this.exInfyForm.updateValueAndValidity();
    // }
  }

  resetForm() {
    //to reset genmodel
    this.dynamicFormComponent.form.reset();
    this.exInfyForm.reset();
    this.publicationDetails = null;
    this.referenceCode.setValue('');
    this.refereeId.setValue('');
    this.subconId.setValue('');
    this.publicationDetails = null;
    this.fileData = null;
    this.fileCheck = false;
    this.formSubmission = false;
    this.referalFlag = false;
    this.codeFlag = false;
    this.exInfy = false;
    this.attachmentRef.fileNameArray.splice(0, this.attachmentRef.fileNameArray.length);
    this.dynamicFormComponent.resetChipFullWidth();
    this.referenceCode.reset();
  }

  //to get interview city id
  getCityID(selectedCityName) {
    let selctdCityKey: number = null;
    this.reqgenModel.fields.forEach((el, _indx) => {
      if (el.name.includes('interview_location')) {
        el.options.forEach((el2, _indx2) => {
          if (el2.value === selectedCityName) {
            selctdCityKey = el2.key;
          }
        });
      }
    });
    return selctdCityKey;
  }

  getGenderID(selectedGenderName) {
    let selctdGenderKey: number = null;
    this.reqgenModel.fields.forEach((el, _indx) => {
      if (el.name.includes('gender')) {
        el.options.forEach((el2, _indx2) => {
          if (el2.value === selectedGenderName) {
            selctdGenderKey = el2.key;
          }
        });
      }
    });
    return selctdGenderKey;
  }

  //to get present employer id
  getEmployerID(selectedEmplyrName) {
    let selctdEmplyrKey: number = null;
    this.reqgenModel.fields.forEach((el, _indx) => {
      if (el.name.includes('previous_employer')) {
        el.options.forEach((el2, _indx2) => {
          if (el2.value === selectedEmplyrName) {
            selctdEmplyrKey = el2.key;
          }
        });
      }
    });
    return selctdEmplyrKey;
  }

  formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }

    return [year, month, day].join('-');
  }

  checkRefCode() {
    if (this.referenceCode.value && this.referenceCode.valid) {
      return false;
    } else {
      return true;
    }
  }

  submit() {
    this.formSubmission = true;
    this.saveAttachment();
  }

  receiveFileOutput(filedata) {
    this.fileData = filedata['fileMerge'];
    if (this.fileData.length > 0) {
      if (this.fileData[0].name) {
        this.fileCheck = true;
      } else {
        this.fileCheck = false;
      }
    } else {
      this.fileCheck = false;
    }
  }

  saveAttachment() {
    // for future
    const _bodyForResumeUpload = {
      objectId: 0,
      objectType: 'CD',
      attachmentId: 1,
    };
    // no cand id, so 0
    // fd.append('createdBy', this.referNowDetails.refereeId);
    // 1 for resume, 2 for photo

    const fd = new FormData();

    fd.append('objectId', '0');
    fd.append('objectType', 'CD');
    fd.append('attachmentId', '1');
    fd.append('companyHiringTypeId', this.companyHiringType);

    if (this.fileData && this.fileData.length > 0) {
      this.fileData.forEach((file) => {
        fd.append('file[' + file.name + ']', file);
      });
      this.ngxLoader.start();
      this.fileService.upload(fd).subscribe(
        (uploadData) => {
          if (uploadData.statusMessage == 'successfully inserted') {
            this.genmodelservice.getskillData().subscribe((res) => {
              this.skills = res;
            });
            //get uploaded mongodb file id to insert in submit call
            // this.mongodbUploadedFileId = Object.keys(res['ids'])[0];
            // this.referNowDetails.id = this.mongodbUploadedFileId;
            const candBody = {
              //"objectId": this.resumeObj.id,
              ...(
                this.publicationDetails.companyHiringTypeId == 1 &&
                localStorage.getItem('roleCode') === 'DBAD'
                  ? { roleCode: 'DBAD' }
                  : {}
              ),
              id: Object.keys(uploadData.ids)[0],
              tenantId: 1,
              companyHiringTypeId: this.publicationDetails.companyHiringTypeId,
              publicationId: this.publicationDetails.publicationId,
              source: this.publicationDetails.sourceId,
              fName: this.dynamicFormComponent.value.fName,
              mName: this.dynamicFormComponent.value.mName ? this.dynamicFormComponent.value.mName : null,
              // "currentLocation": 1,
              lName: this.dynamicFormComponent.value.lName,
              email: this.dynamicFormComponent.value.email,
              dob: this.dynamicFormComponent.value.dob ? this.formatDate(this.dynamicFormComponent.value.dob) : null,
              contactNo:
                '+' +
                this.dynamicFormComponent.value.country_code +
                '-' +
                this.dynamicFormComponent.value.primary_contact_no,
              currentEmployer: this.dynamicFormComponent.value.previous_employer
                ? this.dynamicFormComponent.value.previous_employer
                : '',
              currentEmployerId: this.dynamicFormComponent.value.previous_employer
                ? this.getEmployerID(this.dynamicFormComponent.value.previous_employer)
                : 0,
              interviewLocation: this.dynamicFormComponent.value.interview_location
                ? this.dynamicFormComponent.value.interview_location
                : null,
              interviewCity: this.dynamicFormComponent.value.interview_location
                ? this.getCityID(this.dynamicFormComponent.value.interview_location)
                : null,
              // "skill": this.dynamicFormComponent.value.skill,
              exEmployeeNumber: this.exInfyForm.value.exinfoscion ? this.exInfyForm.value.exinfoscion : null,
              refereeId: this.refereeId.value ? this.refereeId.value : null,
              subconId: this.subconId.value ? this.subconId.value : null,
              experience: this.dynamicFormComponent.value.total_experience
                ? this.dynamicFormComponent.value.total_experience
                : 0,
              skill: this.skills ? this.skills : null,
              gender: this.dynamicFormComponent.value.gender
                ? this.getGenderID(this.dynamicFormComponent.value.gender)
                : null,
              // "exEmployeeNumber": null,
              // "experience": null,
              // "privacyNotice": false,
              // "referenceChk": true,
              // "requestorType": null,
              // "requestorName": this.refereeId.value ? this.refereeId.value :null,
              // "requestorDesignation": null,
              // "requestorOrganization": null,
              // "consentCertification": false,
              // "duplcationCheck": false,
              // "exInfoscianDetails": this.commentVal.value,
              // "selectedOjectId": this.data[0].resume.id
            };

            this.detailsService.AssignapplicationId(candBody).subscribe(
              (data) => {
                this.ngxLoader.stop();
                let msg;
                if (data.candidateResponse.candidateId) {
                  msg = data.candidateResponse.message.statusMessage + ',' + data.candidateResponse.candidateId;
                } else {
                  msg = data.candidateResponse.message.statusMessage;
                }
                if (data.candidateResponse.message.status === 'Success') {
                  this.detailsService.openSnackBar({ msg: msg, isSuccess: 'created' }, 'success-snack');
                  this.resetForm();
                } else {
                  this.detailsService.openSnackBar({ msg: msg, isSuccess: false }, 'danger-snack');
                }
              },
              (_error) => {
                this.ngxLoader.stop();
                this.detailsService.openSnackBar({ msg: 'Something went wrong', isSuccess: false }, 'danger-snack');
              },
            );
          }
        },
        (_error) => {
          this.ngxLoader.stop();
          this.detailsService.openSnackBar({ msg: 'Something went wrong', isSuccess: false }, 'danger-snack');
        },
      );
    }
  }
}
